export const StatusCode = Object.freeze({
  SUCCESS: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  TOO_MANY_REQUESTS: 429,
});

export const PhoneVerificationSteps = Object.freeze({
  Step_1: 0,
  Step_2: 1,
});

export const SubscriptionStatus = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
export const LATER_CLICKED_COOKIE = 'laterClicked';

export const metaMapKeys = {
  matiClientId: process.env.REACT_APP_MATI_CLIENT_ID,
  workFlowId: process.env.REACT_APP_WORKFLOW_FLOW_ID,
};

export const LOCAL_FAVORITES_KEY = 'localFavorites';

export const UserType = Object.freeze({
  SERVICE_PROVIDERS: 'service-providers',
  HOST: 'host',
  GUEST: 'guest',
});

export const EditListingTab = Object.freeze({
  SERVICE_PROVIDER_DETAILS: 'service-provider-details',
  DETAILS: 'details',
});
export const EditListingPathName = Object.freeze({
  NEW_LISTING_PAGE: 'NewListingPage',
  NEW_PROVIDER_LISTING_PAGE: 'NewProviderListingPage',
});

export const ListingFieldConfigKey = Object.freeze({
  RELATED_HOST_CATEGORIES: 'related_host_categories',
  RELATED_SERVICE_CATEGORIES: 'related_service_categories',
});

export const TransactionProcessAlias = Object.freeze({
  BOOKING: 'default-booking/release-1',
});

export const TransactionProcessUnitType = Object.freeze({
  DAY: 'day',
  HOUR: 'hour',
});

export const ListingType = Object.freeze({
  SERVICE_PROVIDER: 'service-provider',
});

export const PricingType = Object.freeze({
  HOURLY: 'hourly',
  PER_JOB: 'perJob',
  FLAT_RATE: 'flatRate',
});

export const BASE_LISTING_TYPES = Object.freeze({
  BOOK_BY_HOUR: 'book-by-hour',
  BOOK_BY_NIGHT: 'book-by-night',
  BOOK_BY_DAY: 'book-by-day',
  BOOK_BY_WEEK: 'book-by-week',
});

export const LISTING_TYPES = Object.freeze({
  ...BASE_LISTING_TYPES,
});

export const AnswerOption = Object.freeze({
  YES: 'yes',
  NO: 'no',
});

export const BASE_LISTING_USER_TYPES = Object.freeze({
  PROVIDER: 'provider',
  HOST: 'host',
});
